import { Einheit } from 'app/models/core/einheit.model';
import { BnrGpPosModel } from '../bnr.gp.pos.model';
import { PosUnDef } from '../gp';

const posDef: BnrGpPosModel[] = [];

// Gesetzliche Weiterbildungspflicht
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 2235001,
		group: 'gwp',
		posText: 'Weiterbildung IDD ',
		posDesc: 'Voraussetzung für die Bonifikation ist der Nachweis von 15 Weiterbildungsstunden im Geschäftsjahr',
		planKey: 'idd',
		einheit: Einheit.stck,
	}),
);
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 2235002,
		group: 'gwp',
		posText: 'Weiterbildung Kapitalmarktwissen',
		posDesc: 'Nachweis von 4 Weiterbildungsstunden Kapitalmarktwissen für die Fonds-Positionen',
		planKey: 'weiterbildungfonds',
		einheit: Einheit.bew,
	}),
);

// Vertriebsschwerpunkte (außerhalb der Maximierung)
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 2235005,
		group: 'vss',
		posText: 'Qualität in Beratung und Vertrieb',
		posDesc: 'LPV beurteilt die individuelle Zielerreichung anhand konkreter Kriterien',
		planKey: '',
		einheit: Einheit.quali,
	}),
);
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 2235021,
		group: 'vss',
		posText: 'Nettomittelzufluss',
		posDesc: 'Individuelles Arbeitsgebietsziel',
		planKey: 'nettomittelzufluss',
		einheit: Einheit.bew,
		boniStufen: 2,
	}),
);
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 2235131,
		group: 'vss',
		posText: 'Leben Einmalbeitrag',
		posDesc: 'Anzahl GV/HV mit mindestens 2.500 Bewertung ohne ZE',
		planKey: 'lebenknpebdigi',
		einheit: Einheit.bew,
	}),
);

// Eingangshürde
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 2235121,
		group: 'eh',
		posText: 'FRV-Zusatzbewertung',
		posDesc: 'Summe der Zielerfüllungen im individuellen Arbeitsgebiet plus 1,5-fache Wertung PrivateFinance-/PrivateMarketsPolice Bewertung',
		planKey: '',
		einheit: Einheit.bew,
	}),
);
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 2275621,
		group: 'eh',
		posText: 'Fonds',
		posDesc: 'Bewertung',
		planKey: 'fondsbew',
		einheit: Einheit.bew,
	}),
);
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 2235101,
		group: 'eh',
		posText: 'Fonds',
		posDesc: 'Bewertung individuelles Arbeitsgebietsziel',
		planKey: 'fondsbew',
		einheit: Einheit.bew,
	}),
);

// Nach Eingangshürde (innerhalb einer Maximierung von 8.000 EUR)
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 2235101,
		group: 'neh',
		posText: 'Fonds',
		posDesc: 'Bewertung',
		planKey: 'fondsbew',
		einheit: Einheit.bew,
		boniStufen: 3,
	}),
);
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 2235111,
		group: 'neh',
		posText: 'Fonds Firmen',
		posDesc: 'Nettomittelzufluss',
		planKey: 'fondsnettomittelzufluss',
		einheit: Einheit.bew,
		boniStufen: 2,
	}),
);
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 2235121,
		group: 'neh',
		posText: 'FRV-Zusatzbewertung',
		posDesc: 'plus 1,5-fache Wertung PrivateFinance-/PrivateMarketsPolice Bewertung',
		planKey: '',
		einheit: Einheit.bew,
		boniStufen: 2,
	}),
);
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 2235134,
		group: 'neh',
		posText: 'Leben Einmalbeitrag',
		posDesc: 'Bewertung ohne ZE mit 1,5-facher Wertung PrivateFinance-/PrivateMarketsPolice',
		planKey: 'lebenknpebdigi',
		einheit: Einheit.bew,
	}),
);

// GeschäftsplanPlus (ohne Eingangshürde und innerhalb einer Maximierung von 3.000 EUR)
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 3835021,
		group: 'gpplus',
		posText: 'Wiederanlage',
		posDesc: 'Wiederanlagesumme',
		planKey: 'wiederanlagesumme',
		einheit: Einheit.bew,
	}),
);
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 3835031,
		group: 'gpplus',
		posText: 'Fonds Firmen',
		posDesc: 'Bewertung',
		planKey: '',
		einheit: Einheit.bew,
	}),
);

// Teamausschreibung
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 3835400,
		group: 'gpplus',
		posText: 'Teamausschreibung',
		posDesc: 'Platzierung in den Positionen im GSW der Vertriebsdirektion',
		planKey: '',
		einheit: Einheit.nogoal,
	}),
);
posDef.push(new BnrGpPosModel({ year: 2026, posId: PosUnDef, group: 'gpplus', posText: '', posDesc: 'Kundenzuwachs', planKey: '', einheit: Einheit.nogoal }));
posDef.push(new BnrGpPosModel({ year: 2026, posId: PosUnDef, group: 'gpplus', posText: '', posDesc: 'Cross-Selling', planKey: '', einheit: Einheit.nogoal }));
posDef.push(new BnrGpPosModel({ year: 2026, posId: PosUnDef, group: 'gpplus', posText: '', posDesc: 'Meine Allianz', planKey: '', einheit: Einheit.nogoal }));

export const KmePositionen = posDef;
